import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
  Chip,
  Grid,
  Paper,
  Avatar
} from '@mui/material';

import { MdPerson } from 'react-icons/md';

const DetailRow = ({ label, value }) => (
  <Box sx={{ mb: 2 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ display: 'block', mb: 0.5 }}
    >
      {label}
    </Typography>

    <Typography
      variant="body2"
      fontWeight={600}
      sx={{
        wordBreak: 'break-word'
      }}
    >
      {value || '—'}
    </Typography>
  </Box>
);

const SectionCard = ({ title, children }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2.5,
      borderRadius: 3,
      border: '1px solid #e0e0e0',
      height: '100%'
    }}
  >
    <Typography
      variant="subtitle1"
      fontWeight={700}
      sx={{ mb: 2 }}
    >
      {title}
    </Typography>

    <Divider sx={{ mb: 2 }} />

    {children}
  </Paper>
);

const ViewManagerDialog = ({ open, onClose, manager }) => {
  if (!manager) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle sx={{ pb: 5 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
          <Avatar
            sx={{
              width: 48,
              height: 48,
              bgcolor: 'primary.main'
            }}
          >
            <MdPerson size={24} />
          </Avatar>

          <Box>
            <Typography variant="h6" fontWeight={700}>
              Manager Details
            </Typography>

            <Typography variant="body2" color="text.secondary">
              View manager profile information
            </Typography>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        <Grid container spacing={3}>
          
          {/* LEFT COLUMN */}
          <Grid item xs={12} md={6}>
            <SectionCard title="Account Information">
              <DetailRow label="Full Name" value={manager.name} />

              <DetailRow label="Email Address" value={manager.email} />

              <DetailRow
                label="Phone Number"
                value={manager.phone || manager.contact}
              />

              <DetailRow
                label="Joined Date"
                value={manager.registrationDate}
              />

              <Box sx={{ mt: 1 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ display: 'block', mb: 1 }}
                >
                  Account Status
                </Typography>

                <Chip
                  label={manager.status === 1 ? 'Active' : 'Inactive'}
                  color={manager.status === 1 ? 'success' : 'error'}
                  size="small"
                />
              </Box>
            </SectionCard>
          </Grid>

          {/* RIGHT COLUMN */}
          <Grid item xs={12} md={6}>
            <SectionCard title="Organization Information">
              <DetailRow
                label="Organization Name"
                value={manager.organization_name}
              />

              <DetailRow
                label="Designation"
                value={manager.designation}
              />

              <DetailRow
                label="State"
                value={manager.stateName}
              />

              <DetailRow
                label="City"
                value={manager.cityName}
              />

              <DetailRow
                label="Address"
                value={manager.address}
              />
            </SectionCard>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewManagerDialog;